import { ComponentManager, DataTransferObject } from "radpresentation.htmlclient.defaultviewextensions";

export default class WFEUserTaskCompleteInformationDTO extends DataTransferObject {
    public Title: any;
    public TitleLabel: any;
    public Assignee: any;
    public AssigneeLabel: any;
    public Description: any;
    public DescriptionLabel: any;
    public DetailsLabel: any;
    public DueDate: any;
    public DueDateLabel: any;
    public Instance: any;
    public InstanceLabel: any;
    public IsCompleted: any;
    public IsCompletedLabel: any;
    public Steps: any;

    constructor() {
        super({
            xmlProperties: [
                'Title',
                'TitleLabel',
                'Assignee',
                'AssigneeLabel',
                'Description',
                'DescriptionLabel',
                'DetailsLabel',
                'DueDate',
                'DueDateLabel',
                'Instance',
                'InstanceLabel',
                'IsCompleted',
                'IsCompletedLabel',
                'Steps'
            ],
            xmlNamespace: 'WorkflowEngine'
        });

        this.Title = this.defaultFromType('string');
        this.TitleLabel = this.defaultFromType('string');
        this.Assignee = this.defaultFromType('string');
        this.AssigneeLabel = this.defaultFromType('string');
        this.Description = this.defaultFromType('string');
        this.DescriptionLabel = this.defaultFromType('string');
        this.DetailsLabel = this.defaultFromType('string');
        this.DueDate = this.defaultFromType('string');
        this.DueDateLabel = this.defaultFromType('string');
        this.Instance = this.defaultFromType('string');
        this.InstanceLabel = this.defaultFromType('string');
        this.IsCompleted = this.defaultFromType('string');
        this.IsCompletedLabel = this.defaultFromType('string');
        this.Steps = this.defaultFromType('array');
    }
}

ComponentManager.setModel('WFEUserTaskCompleteInformationDTO', WFEUserTaskCompleteInformationDTO, 'WorkflowEngineHTMLViewExtension');